module.exports = __webpack_public_path__ + "static/media/login_logo.4fe41b9a.png";